import axios from "axios";
import { getConfig } from "../../modules/Config/Config";
import { ImportSummary, ImportRowError } from "../models/ProductCapabilitiesModels";

export interface ExportPayload {
  blob: Blob;
  contentDisposition: string | null;
  contentType: string;
}

async function importCsv(plantCode: string, file: File): Promise<ImportSummary> {
  const backendConfig = await getConfig("backend");
  const formData = new FormData();
  formData.append("file", file, file.name);

  try {
    const response = await axios.post<ImportSummary>(
      `${backendConfig.url}/productcapabilities/${plantCode}/import`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (err: any) {
    if (err?.response?.status === 422 && err.response.data) {
      const data = err.response.data as Partial<ImportSummary>;
      return {
        imported: 0,
        errors: (data.errors as ImportRowError[] | undefined) ?? [],
      };
    }
    throw err;
  }
}

async function exportCsv(plantCode: string, includeInactive: boolean): Promise<ExportPayload> {
  const backendConfig = await getConfig("backend");

  const response = await axios.get<Blob>(
    `${backendConfig.url}/productcapabilities/${plantCode}/export`,
    {
      params: { includeInactive },
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    contentDisposition: (response.headers["content-disposition"] as string | undefined) ?? null,
    contentType: (response.headers["content-type"] as string | undefined) ?? "text/csv",
  };
}

export { importCsv, exportCsv };
